/* Copyright (c) 2017 Backpack Health LLC */

/* eslint-disable new-cap */
/* global window, INTERCOM_APP_ID */

const APP_ID = INTERCOM_APP_ID;
const APP_CONTEXT = 'groups';

const CustomerService = {

  initAnonymous() {
    if (!APP_ID) { return; }

    window.Intercom('boot', {
      app_id: APP_ID,
      context: APP_CONTEXT,
      hide_default_launcher: true,
    });
  },

  initUser(email, userName, cuid, verificationHash, language_override) {
    if (!APP_ID) { return; }

    window.Intercom('boot', {
      app_id: APP_ID,
      context: APP_CONTEXT,
      user_id: cuid,
      user_hash: verificationHash,
      email,
      name: userName,
      cuid,
      hide_default_launcher: true,
      language_override,
    });
  },

  show() {
    return;
  },

  hide() {
    return;
  },

  showMessengerPanel() {
    return;
  },

  hideMessengerPanel() {
    return;
  },

  shutdown() {
    return;
  },

  updateLanguage(language_override) {
    return;
  },

  updateStyles() {
    window.intercomSettings = Object.assign({}, window.intercomSettings, {
      horizontal_padding: 24,
      vertical_padding: 24,
    });

    window.Intercom('update', window.intercomSettings);
  },

  /*
    Intercom('showMessages');
    Intercom('showNewMessage');
    Intercom('showNewMessage', 'pre-populated content');
    Intercom('onHide', function() { // Do stuff });
    Intercom('onShow', function() { // Do stuff });
    Intercom('onUnreadCountChange', function(unreadCount) {
      // Do stuff...
    });
    Intercom('trackEvent', 'invited-friend');
    Intercom('trackEvent', 'invited-friend', metadata);
    Intercom('getVisitorId')
  */

};

export default CustomerService;
